import { useCallback } from "react";
import {
  ControlcenterMelcoModelsMachineLicense,
  LicenseManagerApi,
  useAPIAction,
} from "melco-shared-logic";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getUTCObjectFromLocalDate } from "../../helper/dateHelper";

dayjs.extend(utc);
export interface CreateLicenseManagerInterface {
  email_address?: string;
  product_code: string;

  sub_type: string;

  is_validate_only: boolean;
  language?: string | null;
  melco_customer_id?: string | null;
  sub_started_on?: Date | null;
  number_of_machines?: number;
  license_key?: string | null;
  subscription_cost?: number | null;
}

export const useCreateMachineLicensesManager = () => {
  const [MachineLicense] = useAPIAction(
    LicenseManagerApi,
    async (
      api,
      LicenseManagerDetails: ControlcenterMelcoModelsMachineLicense
    ) => {
      const localDate = LicenseManagerDetails.sub_started_on;

      let data = await api.licenseManagerLicensesManagerCreateMachineLicense({
        controlcenterMelcoModelsMachineLicense: {
          license_key: LicenseManagerDetails.license_key,
          number_of_machines: LicenseManagerDetails.number_of_machines,
          //  assign_license: LicenseManagerDetails.assign_license,
          product_code: LicenseManagerDetails.product_code,
          email_address: LicenseManagerDetails.email_address,
          //referral_code: LicenseManagerDetails.referral_code,
          //sub: LicenseManagerDetails.sub_type,
          subscription_cost: LicenseManagerDetails.subscription_cost,
          sub_type: LicenseManagerDetails.sub_type,
          //version_id: LicenseManagerDetails.version_id,
          is_validate_only: LicenseManagerDetails.is_validate_only,
          language: LicenseManagerDetails.language,
          //  melco_customer_id: LicenseManagerDetails.melco_customer_id,
          sub_started_on: localDate
            ? getUTCObjectFromLocalDate(localDate).utcStartOfDay
            : undefined,
        },
      });

      return {
        successMessages: !LicenseManagerDetails.is_validate_only
          ? [{ message: "default" }]
          : [],
        data,
      };
    },
    {
      skipErrorHandling: true,
      translationPrefix: "licensemanager.create",
    }
  );

  return useCallback(
    async (LicenseManagerDetails: CreateLicenseManagerInterface) => {
      return await MachineLicense(LicenseManagerDetails);
    },
    [MachineLicense]
  );
};
